module.exports = __webpack_public_path__ + "static/media/jogja.e82aeb21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jogja.jpg
// module id = 129
// module chunks = 0